import { cn } from '@styleguide/lib/utils'

interface GoodPartyOrgLogoProps {
  className?: string
  /**
   * Visual size of the logo (applies Tailwind width/height utilities).
   * – small  : 24 × 20
   * – default: 34 × 28
   * – large  : 50 × 42
   * – xl     : 80 × 67
   */
  size?: 'small' | 'default' | 'large' | 'xl'
}

const sizeClasses = {
  small: 'w-6 h-5',
  default: 'w-[34px] h-[28px]',
  large: 'w-[50px] h-[42px]',
  xl: 'w-20 h-[67px]',
} as const

/**
 * @summary Use for the GoodParty.org heart alone, in tight spots like a chat
 * avatar or mobile top bar. For the name beside the heart, use
 * GoodPartyOrgLogoWordmark.
 */
export const GoodPartyOrgLogo = ({
  className = '',
  size = 'default',
}: GoodPartyOrgLogoProps) => (
  <svg
    data-slot="good-party-org-logo"
    className={cn(sizeClasses[size], className)}
    viewBox="0 0 160 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80.014 123.163C112.708 107.269 134.411 89.4353 145.494 71.1394C154.822 55.6157 156.023 40.554 150.112 28.0795C144.755 16.8063 133.95 8.76726 121.389 6.64199C107.998 4.42431 94.4216 9.13688 83.7084 20.8721L79.9217 24.9378L76.1351 20.8721C65.3295 9.13688 51.7533 4.42431 38.4541 6.64199C25.9861 8.67486 15.0881 16.8063 9.73147 28.0795C3.82072 40.4616 5.02134 55.6157 14.3493 71.1394C25.4319 89.4353 47.1356 107.269 79.8294 123.163H80.014Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.0134 15.882C68.0995 3.40753 52.7686 -1.95188 37.5299 0.635414C23.0301 3.0379 10.4697 12.3707 4.18954 25.4919C-2.73713 40.184 -1.07479 57.5559 9.17668 74.3733C21.0905 94.1476 44.0871 112.628 77.3351 128.706L80.0134 130L82.6918 128.706C115.94 112.536 138.844 94.0552 150.85 74.3733C161.009 57.5559 162.764 40.184 155.837 25.4919C149.557 12.2782 136.997 3.0379 122.497 0.635414C107.258 -1.85947 91.9272 3.40753 80.0134 15.882ZM71.609 25.2147C62.0964 14.8656 50.5519 11.077 39.4693 12.9251C28.9408 14.6807 19.7975 21.5185 15.3645 30.8513C10.562 41.0156 11.2085 53.8597 19.7052 67.9974C29.5872 84.3528 49.259 100.985 79.9211 116.232C110.583 100.985 130.163 84.3528 140.137 67.9974C148.726 53.8597 149.28 41.0156 144.478 30.8513C140.045 21.4261 130.901 14.6807 120.373 12.9251C109.29 11.077 97.7456 14.8656 88.233 25.2147L79.9211 34.2702L71.609 25.2147Z"
      fill="#DC1438"
    />
    <path
      d="M76.6892 78.5324L67.8232 83.1525C66.8996 83.6146 65.7913 83.2449 65.3295 82.4133C65.1448 82.0437 65.0524 81.6741 65.1448 81.2121L66.8073 71.5097C67.1767 69.1996 66.4378 66.8896 64.7754 65.3187L57.5717 58.3885C56.8329 57.6492 56.8329 56.5404 57.5717 55.8012C57.8488 55.524 58.2182 55.3392 58.6799 55.2468L68.6543 53.8607C70.9632 53.4911 72.9951 52.105 74.011 49.9797L78.444 41.109C78.9058 40.185 80.0141 39.8154 80.9377 40.2774C81.3071 40.4622 81.5841 40.7394 81.7688 41.109L86.2018 49.9797C87.2178 52.0126 89.2496 53.4911 91.5585 53.8607L101.533 55.2468C102.549 55.4316 103.288 56.3556 103.103 57.2796C103.103 57.6492 102.826 58.0188 102.549 58.296L95.3451 65.2263C93.6827 66.7971 92.8515 69.1997 93.3133 71.4174L94.9757 81.1197C95.1604 82.1361 94.5139 83.0602 93.498 83.245C93.1286 83.245 92.6668 83.2449 92.2973 83.0601L83.4313 78.44C81.3071 77.3311 78.8135 77.3311 76.7817 78.44L76.6892 78.5324Z"
      fill="#0048C2"
    />
  </svg>
)
